import React from "react";
import useMyOrderCards from "./myOrderCard-hook";
import { useNoAuthHooks } from "../../../../../../../../../Hooks/hooks";
import { formatDate } from "../../../../../../../../../Utilits/utilits";
import { IOrderResponse } from "../../../../../../../../../Interfaces/responseTypes";
import { MyOrderStatus } from "../MyOrderStatus/myOrderStatus";
import styles from './orderCard.module.scss';

interface IProps {
  order: IOrderResponse;
  onSelect: (order: IOrderResponse) => void;
}

const OrderCard: React.FC<IProps> = ({ order, onSelect }) => {
  const orderParams = JSON.parse(order.order_parameters);
  const { baseURL } = useNoAuthHooks();

  const { getOrderCardContent, truncateCompanyName } = useMyOrderCards();
  const { icon, typeLabel, extraFields } = getOrderCardContent(
    order.order_type,
    orderParams,
    order.data
  );

  return (
    <div className={styles.orderCard} onClick={() => onSelect(order)}>
      <div className={styles.topRow}>
        <div className={styles.leftSide}>
          {icon}
          <div>
            <h3>{typeLabel}</h3>
            <div>
              <p className={styles.date}>
                {formatDate(order.created_at!)}
              </p>
              <MyOrderStatus status={order.status} />
            </div>
          </div>
        </div>

        <div className={styles.rightSide}>
          {orderParams.company_logo && (
            <img
              src={`${baseURL}${orderParams.company_logo}`}
              alt={`${orderParams.company_name} logo`}
              className={styles.companyLogo}
            />
          )}
          <p className={styles.companyName}> {truncateCompanyName(orderParams.company_name)}</p>
        </div>
      </div>

      <div className={styles.middleSide}>
        {extraFields}
      </div>
    </div>
  );
};

export default OrderCard;
